/**
 * Метка ключа на каждой строке `t()` — только в режиме правки подписей (`./incontext`).
 * Отдельный модуль, чтобы `index.ts` подключал его без цикла импортов.
 */
import type { PostProcessorModule } from 'i18next';

let marking = false;

export function setMarking(on: boolean): void {
  marking = on;
}

export function isMarking(): boolean {
  return marking;
}

export const incontextPostProcessor: PostProcessorModule = {
  type: 'postProcessor',
  name: 'ismIncontext',
  process(value: unknown, key: string | string[]) {
    if (!marking || typeof value !== 'string' || !window.IsmIncontext) return value as string;
    return window.IsmIncontext.mark(Array.isArray(key) ? key[0] : key, value);
  },
};
